import { useCanvasSectionPreview } from "../context/CanvasSectionPreviewContext";

/** True when this node is highlighted as a pending section member during draw/drag/resize. */
export function useSectionPreviewHighlight(nodeId: string): boolean {
  const { sectionPreview } = useCanvasSectionPreview();
  return sectionPreview?.memberIds.has(nodeId) ?? false;
}
